import { render, staticRenderFns } from "./TemplateConMenuLateral.vue?vue&type=template&id=f4871db6&scoped=true&"
import script from "./TemplateConMenuLateral.vue?vue&type=script&lang=js&"
export * from "./TemplateConMenuLateral.vue?vue&type=script&lang=js&"
import style0 from "./TemplateConMenuLateral.vue?vue&type=style&index=0&id=f4871db6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4871db6",
  null
  
)

export default component.exports